export default __webpack_public_path__ + "static/media/Tu_Billetera_Orange.bbc084b9.svg";